import http from "../core/http";
const group = 'vessels';

export const findByRegistrationRequest = async (data) => {
    return await http.post(`${group}/findByRegistration`, data).then(res => res.data).catch(http.defaultCatch);
};
